import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const formatNumberWithDecimalPart = (number) => (Number(number).toFixed(2));

export default class Rating extends PureComponent {
  static propTypes = {
    averageRate: PropTypes.number.isRequired,
    count: PropTypes.number,
  };

  total = 5;

  render() {
    const { averageRate, count } = this.props;
    const averageRateStyle = { width: `${(averageRate / this.total) * 100}%` };
    const shouldShowCount = count > -1;
    const countClassNames = classNames(
      'fop-rating__count',
      { 'fop-rating__count--long': count >= 1000 }
    );

    return (
      <>
        <span className="fop-rating">
          <span
            className="fop-rating-inner"
            style={averageRateStyle}
            title={`Reviews ${formatNumberWithDecimalPart(averageRate)} out of ${this.total}`}
          />
        </span>
        {shouldShowCount && <span className={countClassNames}>({count})</span>}
      </>
    );
  }
}
